import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { Box, useTheme } from '@mui/material';
import EastIcon from '@mui/icons-material/EastRounded';
import './styles.scss';

interface Props extends ButtonProps {
  to?: string;
  paper?: boolean;
  color?: 'primary' | 'secondary' | 'inherit' | 'success' | 'error' | 'info' | 'warning';
}

const ArrowButton: React.FC<Props> = ({ sx, paper = false, color = 'primary', ...props }) => {
  const theme = useTheme();
  const lightBackgroundColor = paper
    ? theme.palette.background.paper
    : theme.palette.background.default;
  const selectedColor = color === 'inherit' ? 'primary' : color;
  const arrowColor = theme.palette[selectedColor].contrastText;

  return (
    <Button
      variant="contained"
      color={color}
      {...props}
      className="arrow-button"
      startIcon={
        <Box
          className="arrow-icon"
          sx={{
            backgroundColor: theme.palette[selectedColor].main,
            borderRightColor: theme.palette.background.default,
            color: arrowColor,
          }}
        >
          <EastIcon />
        </Box>
      }
      sx={
        theme.palette.mode === 'light'
          ? ({
              backgroundColor: lightBackgroundColor,
              ...butttonStyles,
              color: theme.palette.text.primary,
              '&:hover': {
                color: arrowColor,
                background: theme.palette[selectedColor].main,
              },
              ...sx,
            } as any)
          : {
              backgroundColor: theme.palette.text.primary,
              ...butttonStyles,
              color: theme.palette.primary.contrastText,
              '&:hover': {
                color: arrowColor,
                background: theme.palette[selectedColor].main,
              },
              ...sx,
            }
      }
    />
  );
};

export default ArrowButton;

const butttonStyles = {
  paddingLeft: 0.5,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '19px',
  letterSpacing: '1.6px',
};
